<annotated-control [field]="field">
  <basic-select [id]="field.attributes.id"
                [(value)]="value"
                [placeholder]="field.attributes.placeholder"
                [disabled]="disabled"
                [options]="options"
                (blur)="touch()"></basic-select>
</annotated-control>
